import { useState } from "react";
import { Check, ChevronsUpDown, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Searchable combobox with an optional "Create new" action.
export function AjaxSelect({ value, onChange, options = [], placeholder = "Select…", onCreate, testId }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const q = query.trim();
  const exact = options.some((o) => o.toLowerCase() === q.toLowerCase());

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" data-testid={testId}
          className="w-full justify-between font-normal">
          <span className="truncate">{value || <span className="text-muted-foreground">{placeholder}</span>}</span>
          <ChevronsUpDown size={14} className="opacity-50 shrink-0 ml-2" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width]" align="start">
        <Command>
          <CommandInput placeholder="Type to search…" value={query} onValueChange={setQuery}
            data-testid={testId ? `${testId}-input` : undefined} />
          <CommandList className="max-h-64">
            <CommandEmpty>No matches.</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o} value={o} onSelect={() => { onChange(o); setOpen(false); }}>
                  <Check size={14} className={`mr-2 ${value === o ? "opacity-100" : "opacity-0"}`} />
                  {o}
                </CommandItem>
              ))}
            </CommandGroup>
            {q && !exact && onCreate && (
              <CommandGroup>
                <CommandItem value={`__create__${q}`} data-testid={testId ? `${testId}-create` : undefined}
                  onSelect={async () => {
                    const created = await onCreate(q);
                    if (created) onChange(created);
                    setOpen(false); setQuery("");
                  }}>
                  <Plus size={14} className="mr-2 text-accent" /> Create “{q}”
                </CommandItem>
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
